<template>
  <div class="chart" ref="chart"></div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import * as echarts from "echarts";

export default {
  name: "ConsoleChart5",
  extends: BaseVue,
  props: {
    year: {
      require: true,
      default: new Date().getFullYear()
    },
  },
  data() {
    return {
      option: {
        color: ['#2b85e4'],
        grid:{
          bottom:20,
          left: 50,
          right: 50,
          top: 50
        },
        title: {
          text: "季度节电率统计",
          left: "center",
          textStyle: {
            fontSize:14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: true,
          left: 'right',
          top: 0,
          feature: {
            mark: {show: true},
            saveAsImage: {show: true}
          }
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            name: '%',
            type: 'value',
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '节电率',
            type: 'line',
            smooth: true,
            boundaryGap: true,
            label: {
              show: false
            },
            data: []
          }
        ]
      },
      chart: null
    }
  },
  created() {
    this.$nextTick(()=> {
      this.chart = echarts.init(this.$refs["chart"]);
      this.chart.setOption(this.option);
    });
  },
  watch: {
    year: {
      immediate: true,
      handler() {
        this.query();
      }
    }
  },
  methods: {
    query() {
      this.postForm("/device-month-info/quarterSaveTotalInfo",{
        y: this.year
      }).then((dr)=>{
        this.option.xAxis[0].data = []
        this.option.series[0].data = [];
        dr.rows.forEach((item)=>{
          this.option.xAxis[0].data.push(item.quarter+"季");
          this.option.series[0].data.push(item.savePercent);
        });
        this.chart.setOption(this.option);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/css/variables";
.chart{
  padding: 10px;
  height: 250px;
  border: 1px solid $color-border-primary;
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>